import { render, staticRenderFns } from "./StatusBanner.vue?vue&type=template&id=6cd8f5a4&scoped=true"
import script from "./StatusBanner.vue?vue&type=script&lang=js"
export * from "./StatusBanner.vue?vue&type=script&lang=js"
import style0 from "./StatusBanner.vue?vue&type=style&index=0&id=6cd8f5a4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd8f5a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cd8f5a4')) {
      api.createRecord('6cd8f5a4', component.options)
    } else {
      api.reload('6cd8f5a4', component.options)
    }
    module.hot.accept("./StatusBanner.vue?vue&type=template&id=6cd8f5a4&scoped=true", function () {
      api.rerender('6cd8f5a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/support/StatusBanner.vue"
export default component.exports